// extracted by mini-css-extract-plugin
module.exports = {"submittedContainer":"Feedback_submittedContainer___niap","submittedContent":"Feedback_submittedContent__ADE68","csLink":"Feedback_csLink__L0hGd"};